import { SVGProps } from 'react';

import { NEUTRALS_PALETTE } from '../theme/Themes/palette';

interface VinCarLogoMarkProps extends SVGProps<SVGSVGElement> {
  color?: 'black' | 'white';
}

const VinCarLogoMark = ({ color = 'black', ...props }: VinCarLogoMarkProps) => {
  const colorValue = NEUTRALS_PALETTE[color];

  return (
    <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.4456 12.9999L18.431 21.4909C17.7244 22.0645 16.9564 22.5492 16.1432 22.935L14.4246 18.7994L12.2564 23.969C11.984 23.9896 11.7097 24 11.434 24C10.7175 24 10.0106 23.9296 9.32084 23.7936L14.4456 12.9999ZM12.1923 15.0961L7.09106 23.1008C6.26264 22.7437 5.47714 22.2858 4.75105 21.737L7.39625 17.9767L1.89017 18.6088C1.76549 18.4104 1.64597 18.2074 1.53186 18C1.15076 17.3072 0.840765 16.5845 0.601881 15.8429L12.1923 15.0961ZM13.8426 9.90384L22.781 10.5227C22.8906 11.4506 22.8965 12.3889 22.7988 13.3179L18.6176 12.8227L21.7134 17.255C21.5965 17.5067 21.4707 17.7552 21.3361 18C20.9761 18.6543 20.5624 19.2642 20.1027 19.8252L13.8426 9.90384ZM2.94259 3.96334L9.33598 14.0962L0.0843295 13.4555C-0.0241764 12.5227 -0.0279722 11.5795 0.0729419 10.646L4.56097 11.1773L1.28089 6.4812C1.36081 6.31931 1.44447 6.15887 1.53186 6C1.9375 5.26264 2.41145 4.5815 2.94259 3.96334ZM11.434 0C12.2486 0 13.0509 0.0909583 13.8295 0.266042L8.73293 11.0001L4.66347 2.32987C5.38317 1.77498 6.16268 1.31014 6.98561 0.945278L8.75401 5.20062L10.9303 0.0116056C11.0976 0.00388868 11.2655 0 11.434 0ZM18.318 2.41857L15.7823 6.02333L20.9986 5.42456C21.1158 5.61233 21.2283 5.80418 21.3361 6C21.7205 6.6989 22.0326 7.42832 22.2724 8.17678L10.9862 8.90389L16.0188 1.00688C16.8347 1.38182 17.6065 1.85566 18.318 2.41857Z"
        fill={colorValue}
      />
    </svg>
  );
};

export default VinCarLogoMark;
